import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IUserInfoState } from ".";
import { IBalances } from "../../types/balances";
import { BonusReason } from "../../model/user-info.interface";

export interface IGetBonusResponse {
    balances?: IBalances;
    fragments?: number;
    reason: BonusReason;
}

export const applyBonuses = createAsyncThunk<IGetBonusResponse, BonusReason>(
    'applyBonus',
    async (reason: BonusReason) => await api.bonuses.applyBonuses(reason)
);

const applyBonusesHandler = (builder: ActionReducerMapBuilder<IUserInfoState>) => {
    builder
        .addCase(applyBonuses.pending, (state: IUserInfoState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(applyBonuses.fulfilled, (state: IUserInfoState, action: PayloadAction<IGetBonusResponse>) => {
            state.loading = false;
            state.bonuses = state.bonuses.filter(bonus => bonus.reason !== action.payload.reason);
        })
        .addCase(applyBonuses.rejected, (state: IUserInfoState) => {
            state.loading = false;
            state.bonuses = [];
            state.error = 'Unable to apply bonus';
        });
};

export default applyBonusesHandler;